import type { IFieldDefinition, IRecord } from '@platform/core/types';

/** Поля конверта запису: їх не маскують (назва — підпис запису всюди; прихований запис — це видимість, а не персональні дані). */
const ENVELOPE: ReadonlySet<string> = new Set(['title', 'status', 'tags', 'code']);

/**
 * Чи приховано від поточного користувача значення поля з персональними даними (07-Security §2.3, ADR-024; маскує сервер, інтерфейс
 * лише показує це): повна картка — перелік `permissions.restrictedFields`; рядок списку (permissions — null) — поле з `pii: true`,
 * ключа якого немає у `values` (сервер прибирає приховані поля зі значень, а решту полів-колонок надсилає завжди, порожні — null).
 * Новий запис (без id) — ніколи: автор заповнює такі поля сам. Чиста функція.
 */
export function isFieldRestricted(
  record: Pick<IRecord, 'id' | 'values' | 'permissions'> | null | undefined, field: Pick<IFieldDefinition, 'key' | 'pii' | 'storage'>,
): boolean {
  if (!record?.id || ENVELOPE.has(field.key)) return false;
  const listed = record.permissions?.restrictedFields;
  if (listed) return listed.includes(field.key);
  return Boolean(field.pii) && field.storage !== 'ext' && !Object.prototype.hasOwnProperty.call(record.values ?? {}, field.key);
}
